import styled from 'styled-components';
export const StyledWrapper = styled.div.withConfig({ displayName: "StyledWrapper", componentId: "-q0p4iu" }) ``;
export const StyledImage = styled.img.withConfig({ displayName: "StyledImage", componentId: "-1v9foaf" }) `
  display: block;
  cursor: pointer;
  max-width: 100%;
  min-height: 200px;
`;
export const StyledOverlay = styled.div.withConfig({ displayName: "StyledOverlay", componentId: "-1x96van" }) `
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${(props) => props.theme.colors.oxfordBlue};
  opacity: ${(props) => props.theme.modal.overlayOpacity};
  z-index: 2;
`;
export const StyledModal = styled.div.withConfig({ displayName: "StyledModal", componentId: "-46d0bp" }) `
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: flex;
  align-items: center;
`;
